var getOfferPskByBankIdAndRate = function (rate, minPsk, maxPsk) {
    if (minPsk && maxPsk) {
        var pskMinValue = minPsk > rate ? Math.floor(rate) : minPsk;
        var pskMaxValue = maxPsk < rate ? Math.ceil(rate) : maxPsk;
        return "".concat(pskMinValue, "% \u2013 ").concat(pskMaxValue, "%");
    }
    return null;
};

export { getOfferPskByBankIdAndRate };
//# sourceMappingURL=psk.js.map
